import { render, staticRenderFns } from "./BaseMultipleSelectOption.global.vue?vue&type=template&id=2ea30950&scoped=true&"
import script from "./BaseMultipleSelectOption.global.vue?vue&type=script&lang=js&"
export * from "./BaseMultipleSelectOption.global.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultipleSelectOption.global.vue?vue&type=style&index=0&id=2ea30950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea30950",
  null
  
)

export default component.exports